export default __webpack_public_path__ + "static/media/0xc778417E063141139Fce010982780140Aa0cD5Ab.7f2a4365.svg";